import { Locales } from "../constants/locales";
import { DomUtils } from "../utils/domUtils";

export const DefaultLocale = Locales.en.id;
export const LocaleLocalStorageKey = "MP_AUTH_LOCALE";

export class LocaleService {
	constructor() {
		const locale = this.GetLocale();
		this._UpdateLocale(locale);
	}

	GetLocale() {
		const locale = window.localStorage.getItem(LocaleLocalStorageKey);
		return locale ?? DefaultLocale;
	}

	SetLocale(locale) {
		window.localStorage.setItem(LocaleLocalStorageKey, locale);

		this._UpdateLocale(locale);
	}

	Translate(key) {
		const locale = this.GetLocale();
		const translation = this._GetTranslation(key, locale);
		return translation;
	}

	SetElementTranslation(elementId, key) {
		const element = DomUtils.GetElement(elementId);
		element.dataset.i18n = key;

		element.innerHTML = this.Translate(key);
	}

	_UpdateLocale(locale) {
		document.documentElement.lang = locale;

		const translatedElements = document.querySelectorAll("[data-i18n]");
		for (const translatedElement of translatedElements) {
			const key = translatedElement.dataset.i18n;
			const text = this._GetTranslation(key, locale);

			if (translatedElement.tagName === "INPUT") {
				translatedElement.placeholder = text;
			}
			else {
				translatedElement.innerText = text;
			}
		}
	}

	_GetTranslation(key, locale) {
		const localeTranslations = this._GetLocaleTranslations(locale);

		let translation;
		if (localeTranslations != null) {
			const [resourceKey, ...values] = key.split("|");

			translation = localeTranslations[resourceKey];

			if (translation != null) {
				translation = translation.replace(/\{(\d+)\}/g, function (match, number) {
					return values[number] != null ? values[number] : "";
				});
			}
		}

		return translation ?? key;
	}

	_GetLocaleTranslations(locale) {
		const localeTranslations = window.i18n?.[locale] ?? {};
		return localeTranslations;
	}
}
